export enum rowType {
    savingsStyle = 'savingsStyle',
    defaultStyle = 'sectionStyle',
    totalStyle = 'totalStyle',
}
